import React from 'react';

const ModuleHierarchyContext = React.createContext();

export default ModuleHierarchyContext;
